module.exports = __webpack_public_path__ + "static/media/logo4.629a98ad.jpg";